import { createSelector } from 'reselect'
import { createMultipleStatusSelectors } from 'store/utils/selectorHelpers'
import types from './types'

const getThemeState = (state) => state.theme

export const selectTheme = createSelector(
  [getThemeState],
  (theme) => theme.data
)

export const {
  selectFetchThemeStatus,
} = createMultipleStatusSelectors(types, getThemeState)



// WEBPACK FOOTER //
// ./src/store/theme/selectors.js